<template>
  <div class="box" v-if="user">
    <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
      <div class="title">Passwort ändern</div>
      <div class="content">
        <div class="block">
          Sie müssen bei der ersten Anmeldung Ihr Passwort ändern. Das Passwort
          muss keine besonderen Bedingungen erfüllen, aber
          <span class="has-text-weight-bold">mindestens 15 Zeichen</span>
          haben. Wählen Sie etwas, das Sie sich leicht merken können wie z.B.
          <li>'Ich mag Apfelkuchen'</li>
          <li>'Born in Brandenburg'</li>
          <li>'Und es war Sommer'</li>
        </div>
      </div>
      <input
        type="text"
        hidden="true"
        id="username"
        name="username"
        autocomplete="username"
        :value="user.credentials.username"
      />
      <div class="field">
        <label for="currentPasswordInput" class="label">Aktuelles Passwort</label>
        <div class="control">
          <Field
            id="currentPasswordInput"
            name="currentPasswordInput"
            class="input"
            :class="{ 'is-danger': errors.length > 0 }"
            type="password"
            v-model="credentials.currentPassword"
            autofocus
            autocomplete="current-password"
          />
        </div>
        <div class="help is-danger">{{ errors.currentPasswordInput || responseErrors.currentPassword?.join(", ") }}</div>
      </div>
      <div class="field">
        <label for="newPasswordInput" class="label">Neues Passwort</label>
        <div class="control">
          <Field
            id="newPasswordInput"
            name="newPasswordInput"
            class="input"
            :class="{ 'is-danger': errors.length > 0 }"
            type="password"
            v-model="credentials.newPassword"
            autocomplete="new-password"
            rules="passwordLength"
          />
        </div>
        <div class="help is-danger">{{ errors.newPasswordInput  || responseErrors.newPassword?.join(", ") }}</div>
      </div>
      <div class="field">
        <label for="newPasswordRepeatInput" class="label">Neues Passwort wiederholen</label>
        <div class="control">
          <Field
            id="newPasswordRepeatInput"
            name="newPasswordRepeatInput"
            class="input"
            type="password"
            v-model="credentials.newPasswordRepeat"
            autocomplete="new-password"
            rules="passwordConfirmed"
          />
        </div>
        <div class="help is-danger">{{ errors.newPasswordRepeatInput  || responseErrors.newPasswordRepeat?.join(", ") }}</div>
      </div>
      <div class="field">
        <div class="control">
          <input
            class="button is-primary"
            type="submit"
            value="Passwort ändern"
          />
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { Field, Form } from "vee-validate";
import { object, string, ref } from "yup";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Form,
    Field,
  },
  setup() {
    const schema = object().shape({
      currentPasswordInput: string().required(
        "Aktuelles Passwort ist ein Pflichtfeld"
      ),
      newPasswordInput: string().required("Neues Passwort ist ein Pflichtfeld").min(15, "Das Passwort muss mindestens 15 Zeichen haben"),
      newPasswordRepeatInput: string().required(
        "Bitte bestätigen Sie das neue Passwort"
      ).oneOf([ref('newPasswordInput')], 'Die Passwörter stimmen nicht überein'),
    });
    return {
      schema,
    };
  },
  data() {
    return {
      responseErrors: [],
      credentials: {
        currentPassword: "",
        newPassword: "",
        newPasswordRepeat: "",
      },
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["changePassword"]),
    onSubmit() {
      this.responseErrors = [];
      this.changePassword(this.credentials).catch((error) => {
        this.responseErrors = error.response.data;
      });
    },
  },
};
</script>
